import { writable } from 'svelte/store';

export const cartsStore = writable({});
export const selectedCartStore = writable(null);
